// Form submission sends line breaks as CRLF and Shopify counts both characters, which native maxlength doesn't.
function giftMessageLength(value) {
  return value.length + (value.match(/\n/g) || []).length;
}

// Trims the text just inserted before the caret, so a paste is cut to fit instead of dropping the tail
function trimToMaxLength(textarea) {
  const after = textarea.value.slice(textarea.selectionStart);
  const before = Array.from(textarea.value.slice(0, textarea.selectionStart));
  while (before.length && giftMessageLength(before.join('') + after) > textarea.maxLength) {
    before.pop();
  }
  const kept = before.join('');
  textarea.value = kept + after;
  textarea.setSelectionRange(kept.length, kept.length);
}

document.addEventListener('input', (event) => {
  const textarea = event.target;
  const recipient = textarea.closest('gift-card-recipient');
  if (!recipient || textarea.name !== 'properties[Message]') {
    return;
  }

  if (giftMessageLength(textarea.value) > textarea.maxLength) {
    trimToMaxLength(textarea);
  }

  const length = giftMessageLength(textarea.value);
  recipient.querySelector('.boa-gift-message__count').textContent = `${length}/${textarea.maxLength}`;
  recipient.querySelector('.boa-gift-message__limit').hidden = length < textarea.maxLength;
});
